import Maze from './Maze.js';
import Room from './Room.js';


const ROOM_WALL_NORTH     = "north";
const ROOM_WALL_SOUTH     = "south";
const ROOM_WALL_EAST      = "east";
const ROOM_WALL_WEST      = "west";

function shuffleArray(a) 
{
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}


export default class PathBuilder
{
  constructor({maze, randomStart=0, randomSeed=0, depthSearch=true})
  {
    this.m_maze = maze;
    this.m_randomStart = randomStart;
    this.m_randomSeed = randomSeed;

    this.m_exit = null;
    this.m_entrance = null;
    this.m_entranceAndExitChosen = false;

    this.m_searchStack = [];
    this.m_depthSearch = depthSearch;        //defaults to true for now
  }


  buildPaths()
  {
    //ensure that entrance and exit have been chosen before continuing 
    if (this.m_entranceAndExitChosen)
    {
      if (this.m_randomStart)
      { // choose a random room to start in 
        let chosenLocation = this.chooseRandomRoom();
        console.info("PathBuilder: chosen start locaiton: ", chosenLocation.x, chosenLocation.y);

        this.m_searchStack.push(chosenLocation);
      }
      else
      {
        // start at the entrance room and move out from there
        this.m_searchStack.push(this.m_entrance);
      }

      let ret = this.pathSearch(this.m_searchStack);

      return ret; 
    }
  }


  chooseEntranceAndExit()
  {
    let entrance = this.chooseExteriorRoom();
    if (entrance == 0)
    {
      //there was a problem choosing an exit
      console.info("PathBuilder error: failed to choose an entrance room");
      return 0;
    }

    // remove the exterior wall
    this.removeExteriorWall(entrance.room, entrance.x, entrance.y);

    this.m_entrance = entrance; 

    let exit = this.chooseExteriorRoom();

    if (exit == 0)
    {
      //there was a problem choosing an exit 
      console.info("PathBuilder error: failed to choose an entrance room");
      return 0;
    }

    this.removeExteriorWall(exit.room, exit.x, exit.y);

    this.m_exit = exit;

    this.m_entranceAndExitChosen = true; 
  }


  //mainly an internal function to be used for selecting random rooms as starting positions, etc
  chooseRandomRoom()
  {
    let width = this.m_maze.getWidth();
    let height = this.m_maze.getHeight();
    let xCoord = Math.floor(Math.random() * width);
    let yCoord = Math.floor(Math.random() * height);

    let chosenRoom = this.m_maze.getRoomAt(xCoord, yCoord);
    if (chosenRoom == 0 || chosenRoom == null)
    { //there was an error choosing the room, so return 0;
        return 0;
    }

    return {x: xCoord, y: yCoord, room: chosenRoom};
  }


  chooseExteriorRoom()
  {
    let width = this.m_maze.getWidth();
    let height = this.m_maze.getHeight();

    let chosenX = -1;       //init with -1 to indicate it hasnt been picked yet
    let chosenY = -1;       //init with -1 to indicate it hasnt been picked yet 

    let entranceSide = Math.floor(Math.random() * 4);        //randomly pick one of four directions
    switch(entranceSide)
    {
      case 0:
      {
        chosenY = 0; 
        break;
      }
      case 1:
      {
        chosenX = width - 1;
        break;
      }
      case 2:
      {
        chosenY = height - 1;
        break;
      }
      case 3:
      {
        chosenX = 0;
        break;
      }
    };

    if (chosenX == -1)
    { //the y coord has been picked, now we need an x coord
      chosenX = Math.floor(Math.random() * width);
    }
    else
    { //the x coord has been picked, now we need a y coord
      chosenY = Math.floor(Math.random() * height);
    }

    //verify that a room exists at the chosen coords 
    let chosenRoom = this.m_maze.getRoomAt(chosenX, chosenY);
    if (chosenRoom == 0 || chosenRoom == null)
    {
      // there was a problem choosing/verifying the room.  Return 0 to indicate that there was an error
      return 0;
    }

    // if we made it this far, we should have a valid room and chosen coords
    // return the chosen room and coords 
    return {x: chosenX, y: chosenY, room: chosenRoom};
  }


  pathSearch(searchStack)
  {
    if (searchStack.length == 0) 
    {
      // the search stack is empty! ... return 1 to indicate that there is nothing to search 
      return 1;
    }

    let currentLoc = null;
    if (this.m_depthSearch)
    { // depth first search time!
      currentLoc = searchStack.pop();
    }
    else
    { //breadth first seach time!
        currentLoc = searchStack.shift();
    }

    let currentRoom = this.m_maze.getRoomAt(currentLoc.x, currentLoc.y);
    if (currentRoom == null || currentRoom == 0)
    {
      //there was an error geting the current search room, return 0 to indicate an error
      console.info("PathBuilder: Error in pathsearch with current room at ", currentLoc.x, currentLoc.y);
      return 0;
    }
    currentRoom.visitRoom();  
    let directions = [ROOM_WALL_NORTH, ROOM_WALL_EAST, ROOM_WALL_WEST, ROOM_WALL_SOUTH];
    directions = shuffleArray(directions);

    directions.forEach((dir) =>
    {
      let dirRoom = null;
      let dirLoc = null;

      switch(dir)
      {
        case ROOM_WALL_NORTH:
        {
          dirLoc = {x: currentLoc.x, y: currentLoc.y - 1};
          dirRoom = this.m_maze.getRoomAt(dirLoc.x, dirLoc.y);
          if (dirRoom != 0 && dirRoom != null)
          {
            if (dirRoom.isVisited() == false)
            { //the room in this direction has not yet been visited. So, visit, tear down walls, and add to stack
              dirRoom.tearDownWall(ROOM_WALL_SOUTH);
              currentRoom.tearDownWall(ROOM_WALL_NORTH);
              searchStack.push(dirLoc);
              this.pathSearch(searchStack);

            }
          }
          break;
        }

        case ROOM_WALL_EAST:
        {
          dirLoc = {x: currentLoc.x + 1, y: currentLoc.y};
          dirRoom = this.m_maze.getRoomAt(dirLoc.x, dirLoc.y);
          if (dirRoom != 0 && dirRoom != null)
          {
            if (dirRoom.isVisited() == false)
            { //the room in this direction has not yet been visited. So, visit, tear down walls, and add to stack
              dirRoom.tearDownWall(ROOM_WALL_WEST);
              currentRoom.tearDownWall(ROOM_WALL_EAST);
              searchStack.push(dirLoc);
              this.pathSearch(searchStack);
            }
          }
          break;
        }

        case ROOM_WALL_WEST:
        {
          dirLoc = {x: currentLoc.x - 1, y: currentLoc.y};
          dirRoom = this.m_maze.getRoomAt(dirLoc.x, dirLoc.y);
          if (dirRoom != 0 && dirRoom != null)
          {
            if (dirRoom.isVisited() == false)
            { //the room in this direction has not yet been visited. So, visit, tear down walls, and add to stack
              dirRoom.tearDownWall(ROOM_WALL_EAST);
              currentRoom.tearDownWall(ROOM_WALL_WEST);
              searchStack.push(dirLoc);
              this.pathSearch(searchStack);
            }
          }
          break;
        }
    
        case ROOM_WALL_SOUTH:
        {
          dirLoc = {x: currentLoc.x, y: currentLoc.y + 1};
          dirRoom = this.m_maze.getRoomAt(dirLoc.x, dirLoc.y);
          if (dirRoom != 0 && dirRoom != null)
          {
            if (dirRoom.isVisited() == false)
            { //the room in this direction has not yet been visited. So, visit, tear down walls, and add to stack
              dirRoom.tearDownWall(ROOM_WALL_NORTH);
              currentRoom.tearDownWall(ROOM_WALL_SOUTH);
              searchStack.push(dirLoc);
              this.pathSearch(searchStack);
            }
          }
          break;
        }
      };

    });

    //continue the search 
    this.pathSearch(searchStack);
  }



  removeExteriorWall(room, xCoord, yCoord)
  {
    let width = this.m_maze.getWidth();
    let height = this.m_maze.getHeight();

    if (room == 0 || room == null)
    { //not a valid room
      return 0;
    }

    if (xCoord == 0)
    { // west wall should be removed
      room.tearDownWall(ROOM_WALL_WEST);
    }
    else if (yCoord == 0)
    { // north wall should be removed
      room.tearDownWall(ROOM_WALL_NORTH);
    }
    else if (xCoord == width - 1)
    { // east wall should be removed 
      room.tearDownWall(ROOM_WALL_EAST);
    }
    else if (yCoord == height - 1)
    { // south wall should be removed
      room.tearDownWall(ROOM_WALL_SOUTH);
    }
    else
    { //not an exterior wall... return 0 to indicate error
      return 0; 
    }

    // wall properly torn down if we got this far.  return 1 to indicate success
    return 1;
  }


};

